import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/icons/lightroom.svg'
import _imports_1 from '@/assets/images/icons/captureone.svg'


const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "w-full grid grid-cols-1 col-span-12 mt-3 sm:mt-0" }
const _hoisted_3 = { class: "w-full sm:max-w-4xl flex flex-col mx-auto" }
const _hoisted_4 = { class: "rounded-lg bg-white shadow-sm col-span-2 sm:col-span-1 mb-4" }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "sm:flex sm:items-center" }
const _hoisted_7 = { class: "sm:flex-auto" }
const _hoisted_8 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_9 = { class: "mt-1 text-sm text-gray-700" }
const _hoisted_10 = {
  key: 0,
  class: "p-5 min-h-56 flex flex-col justify-center items-center text-center"
}
const _hoisted_11 = { class: "max-w-full mx-auto" }
const _hoisted_12 = { class: "mt-2 font-medium text-gray-800" }
const _hoisted_13 = { class: "mb-5 text-sm text-gray-500" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_15 = { class: "grid grid-cols-3 gap-1" }
const _hoisted_16 = ["href"]
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "mx-auto text-gray-500 text-sm" }
const _hoisted_20 = { class: "grow" }
const _hoisted_21 = { class: "flex justify-between" }
const _hoisted_22 = { class: "text-sm font-medium text-gray-800 inline-flex items-center gap-2" }
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 0,
  class: "inline-flex items-center gap-x-1.5 rounded-md px-1.5 py-0.5 text-xs font-medium text-gray-900 ring-1 ring-gray-200 ring-inset"
}
const _hoisted_25 = { class: "mt-1 text-xs text-gray-500" }
const _hoisted_26 = { class: "inline-block relative pe-3 last:pe-0 first-of-type:before:hidden before:absolute before:top-1/2 before:-start-2 before:-translate-y-1/2 before:w-px before:h-3 before:bg-gray-300 before:rounded-full" }
const _hoisted_27 = { class: "inline-block relative pe-3 last:pe-0 first-of-type:before:hidden before:absolute before:top-1/2 before:-start-2 before:-translate-y-1/2 before:w-px before:h-3 before:bg-gray-300 before:rounded-full" }
const _hoisted_28 = { class: "hidden sm:flex gap-2" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "hidden sm:block" }
const _hoisted_31 = { class: "size-4" }
const _hoisted_32 = ["alt"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "size-4" }
const _hoisted_35 = ["alt"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "sm:hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_LightroomModalComponent = _resolveComponent("LightroomModalComponent")!
  const _component_CaptureOneModalComponent = _resolveComponent("CaptureOneModalComponent")!
  const _component_DeleteConfirmationModalComponent = _resolveComponent("DeleteConfirmationModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ControlsMenuComponent, { class: "sm:mb-6" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t('favorites.title')), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('favorites.description')), 1)
              ])
            ])
          ])
        ]),
        (_ctx.favorites.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[4] || (_cache[4] = _createStaticVNode("<svg class=\"w-48 mx-auto mb-4\" width=\"178\" height=\"90\" viewBox=\"0 0 178 90\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"27\" y=\"50.5\" width=\"124\" height=\"39\" rx=\"7.5\" fill=\"currentColor\" class=\"fill-white\"></rect><rect x=\"27\" y=\"50.5\" width=\"124\" height=\"39\" rx=\"7.5\" stroke=\"currentColor\" class=\"stroke-gray-50\"></rect><rect x=\"34.5\" y=\"58\" width=\"24\" height=\"24\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-50\"></rect><rect x=\"66.5\" y=\"61\" width=\"60\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-50\"></rect><rect x=\"66.5\" y=\"73\" width=\"77\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-50\"></rect><rect x=\"19.5\" y=\"28.5\" width=\"139\" height=\"39\" rx=\"7.5\" fill=\"currentColor\" class=\"fill-white\"></rect><rect x=\"19.5\" y=\"28.5\" width=\"139\" height=\"39\" rx=\"7.5\" stroke=\"currentColor\" class=\"stroke-gray-100\"></rect><rect x=\"27\" y=\"36\" width=\"24\" height=\"24\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"59\" y=\"39\" width=\"60\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><rect x=\"59\" y=\"51\" width=\"92\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-100\"></rect><g filter=\"url(#filter19)\"><rect x=\"12\" y=\"6\" width=\"154\" height=\"40\" rx=\"8\" fill=\"currentColor\" class=\"fill-white\" shape-rendering=\"crispEdges\"></rect><rect x=\"12.5\" y=\"6.5\" width=\"153\" height=\"39\" rx=\"7.5\" stroke=\"currentColor\" class=\"stroke-gray-100\" shape-rendering=\"crispEdges\"></rect><rect x=\"20\" y=\"14\" width=\"24\" height=\"24\" rx=\"4\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"52\" y=\"17\" width=\"60\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-200\"></rect><rect x=\"52\" y=\"29\" width=\"106\" height=\"6\" rx=\"3\" fill=\"currentColor\" class=\"fill-gray-200\"></rect></g><defs><filter id=\"filter19\" x=\"0\" y=\"0\" width=\"178\" height=\"64\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\"><feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"></feFlood><feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"></feColorMatrix><feOffset dy=\"6\"></feOffset><feGaussianBlur stdDeviation=\"6\"></feGaussianBlur><feComposite in2=\"hardAlpha\" operator=\"out\"></feComposite><feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0\"></feColorMatrix><feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_1187_14810\"></feBlend><feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_1187_14810\" result=\"shape\"></feBlend></filter></defs></svg>", 1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('favorites.empty')), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('favorites.empty_ask')), 1)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favorites, (favorite, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `favorite-item-${favorite.id}-${index}`,
                  class: "relative group p-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 bg-white border border-gray-200 -mt-px first:mt-0 first:rounded-t-xl last:rounded-b-xl"
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favorite.latest, (item) => {
                      return (_openBlock(), _createElementBlock("a", {
                        href: favorite.public_url,
                        target: "_blank",
                        key: `favorite-item-${favorite.id}-${item.id}`,
                        class: "group relative block sm:w-20 h-24 sm:h-16 flex flex-col justify-center items-center bg-gray-100 border border-gray-200 rounded-lg overflow-hidden after:absolute after:inset-0 hover:after:bg-gray-900/50 after:duration-300 focus:outline-hidden focus:after:bg-gray-900/70"
                      }, [
                        _createElementVNode("img", {
                          src: item.preview_mini_url,
                          class: "object-cover w-full h-full",
                          alt: favorite.title
                        }, null, 8, _hoisted_17)
                      ], 8, _hoisted_16))
                    }), 128)),
                    (favorite.latest.length == 0)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: favorite.public_url,
                          target: "_blank",
                          class: "group relative block col-span-3 sm:w-62 h-24 sm:h-16 flex flex-col justify-center items-center p-3 bg-gray-100 border border-gray-200 first:rounded-s-lg last:rounded-e-lg overflow-hidden after:absolute after:inset-0 after:duration-300 focus:outline-hidden"
                        }, [
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('favorites.latest_empty')), 1)
                        ], 8, _hoisted_18))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_22, [
                          _createElementVNode("a", {
                            class: "hover:text-royal-blue-600 focus:outline-hidden focus:text-royal-blue-600",
                            href: favorite.public_url,
                            target: "_blank"
                          }, _toDisplayString(favorite.title), 9, _hoisted_23),
                          (favorite.is_finished)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                _cache[5] || (_cache[5] = _createElementVNode("svg", {
                                  class: "size-1.5 fill-green-500",
                                  viewBox: "0 0 6 6",
                                  "aria-hidden": "true"
                                }, [
                                  _createElementVNode("circle", {
                                    cx: "3",
                                    cy: "3",
                                    r: "3"
                                  })
                                ], -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('favorites.finished')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("ul", _hoisted_25, [
                          _createElementVNode("li", _hoisted_26, _toDisplayString(_ctx.$t('favorites.updated_at')) + " " + _toDisplayString(favorite.updated_at_formatted), 1),
                          _createElementVNode("li", _hoisted_27, _toDisplayString(favorite.items_count) + " " + _toDisplayString(_ctx.$t('favorites.photos')), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.toggleLightroom(favorite)), ["prevent"]),
                            type: "button",
                            class: "inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm rounded-lg border border-transparent text-gray-500 hover:bg-royal-blue-100/50 focus:outline-hidden focus:bg-royal-blue-100 hover:text-gray-700 focus:outline-hidden focus:bg-royal-blue-100 focus:text-gray-500 disabled:opacity-50 disabled:pointer-events-none cursor-pointer",
                            style: {"--tw-ring-color":"rgb(1 30 54)"}
                          }, [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('favorites.copy')), 1),
                            _createElementVNode("span", _hoisted_31, [
                              _createElementVNode("img", {
                                src: _imports_0,
                                class: "size-4",
                                alt: _ctx.$t('favorites.copy_to_lightroom')
                              }, null, 8, _hoisted_32)
                            ])
                          ], 8, _hoisted_29),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.toggleCaptureOne(favorite)), ["prevent"]),
                            type: "button",
                            class: "inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm rounded-lg border border-transparent text-royal-blue-500 hover:bg-royal-blue-100/50 focus:outline-hidden focus:bg-royal-blue-100 hover:text-royal-blue-600 focus:outline-hidden focus:bg-royal-blue-100 focus:text-royal-blue-500 disabled:opacity-50 disabled:pointer-events-none cursor-pointer"
                          }, [
                            _createElementVNode("span", _hoisted_34, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                class: "size-4",
                                alt: _ctx.$t('favorites.copy_to_capture_one')
                              }, null, 8, _hoisted_35)
                            ])
                          ], 8, _hoisted_33),
                          _createElementVNode("button", {
                            onClick: _withModifiers(($event: any) => (_ctx.remove(favorite)), ["prevent"]),
                            type: "button",
                            class: "ml-2 bg-red-500 text-white p-2 px-3 rounded-md text-sm hover:bg-red-600 focus:outline-none cursor-pointer flex items-center gap-1"
                          }, [
                            _createVNode(_component_TrashIcon, { class: "size-4" })
                          ], 8, _hoisted_36)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_DropdownMenu, {
                          options: _ctx.dropdownOptions,
                          "trigger-text": "More",
                          onAction: (action, option) => _ctx.handleDropdownAction(favorite, action)
                        }, null, 8, ["options", "onAction"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
      ])
    ]),
    _createVNode(_component_LightroomModalComponent, {
      open: _ctx.lightRoom !== null,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lightRoom = null))
    }, null, 8, ["open"]),
    _createVNode(_component_CaptureOneModalComponent, {
      open: _ctx.captureOne !== null,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.captureOne = null))
    }, null, 8, ["open"]),
    _createVNode(_component_DeleteConfirmationModalComponent, {
      open: _ctx.deleteConfirmation !== null,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteConfirmation = null)),
      onConfirmAction: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmRemove(_ctx.deleteConfirmation!)))
    }, null, 8, ["open"])
  ]))
}